import styled from 'styled-components';
import { colors } from 'styles/colors';

export const HomeContainer = styled.div`
  height: 26px;
  display: flex;
  align-items: center;
  gap: 8px;

  & > h1 {
    margin: 0;
    font-weight: 500;
    font-size: 20px;
    line-height: 130%;
    color: ${colors.text['main-900']};
  }
`;
